import { render, staticRenderFns } from "./UpdateStudentMarks.vue?vue&type=template&id=6a80d9b7"
import script from "./UpdateStudentMarks.vue?vue&type=script&lang=js"
export * from "./UpdateStudentMarks.vue?vue&type=script&lang=js"
import style0 from "./UpdateStudentMarks.vue?vue&type=style&index=0&id=6a80d9b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports